import React, { useEffect } from 'react';
import { ProjectRoleContainer } from '../ProjectOverview.styles';
import RoleWithinProject from './RoleItem/RoleWithinProject';
import { useContextSelector } from 'use-context-selector';
import { OpportunitiesContext } from 'pages/Opportunities/context/OpportunitiesContext';
import { Button } from '@material-ui/core';
import ProjectLoaders from 'pages/Opportunities/components/OpportunitiesContent/Loaders/ProjectLoaders';
import { COLORS } from 'shared/constants/COLORS';
import { ICastingAttributes } from 'shared/interfaces/ICasting';
import { ICastingRoleAttributes } from 'shared/interfaces/ICastingRole';

interface Props {
  projectId: string;
  roleId?: string;
  companyName: string;
  totalRoles: number;
  projectName: string;
  castingRolesData?: ICastingRoleAttributes[];
}

const ProjectRoles: React.FC<Props> = ({
  projectId,
  roleId,
  companyName,
  totalRoles,
  projectName,
  castingRolesData,
}) => {
  const getProjectRolesData = useContextSelector(OpportunitiesContext, (v) => v.getProjectRolesData);
  const projectRolesData = useContextSelector(OpportunitiesContext, (v) => v.projectRolesData);
  const projectRolesLoading = useContextSelector(OpportunitiesContext, (v) => v.projectRolesLoading);

  // const roles: IRoleAttributes[] = [];

  useEffect(() => {
    if (!roleId) {
      getProjectRolesData(projectId, false);
    }
  }, [roleId, projectId]);

  console.log('projectRolesData', castingRolesData);

  return (
    <ProjectRoleContainer>
      {/* {projectId} */}
      {roleId ? (
        <RoleWithinProject
          roleId={roleId}
          projectId={projectId}
          companyName={companyName}
          projectName={projectName}
          shared={true}
        />
      ) : (
        // projectRolesData.map((role) => (
        //   <RoleWithinProject key={role.id} roleId={role.id} projectId={projectId} companyName={companyName} />
        // ))
        <React.Fragment />
      )}
      {roleId && !projectRolesData.length && totalRoles > 1 ? (
        <Button
          variant="outlined"
          color="primary"
          onClick={() => getProjectRolesData(projectId, false, [roleId])}
          style={{ background: 'transparent', maxWidth: 300 }}
        >
          View {totalRoles - 1} other roles for this project
        </Button>
      ) : (
        <React.Fragment />
      )}
      {castingRolesData?.length || projectRolesData.length ? (
        (castingRolesData || projectRolesData).map((role) => (
          <RoleWithinProject
            castingRole={role as ICastingRoleAttributes}
            key={role.id}
            roleId={role.slug}
            projectId={projectId}
            companyName={companyName}
            projectName={projectName}
          />
        ))
      ) : (
        <React.Fragment />
      )}

      {projectRolesLoading && <ProjectLoaders />}
    </ProjectRoleContainer>
  );
};

export default ProjectRoles;
